module.exports = __webpack_public_path__ + "assets/b46340ade7f9ee27c5b9bb54f2ed2db6.png";